// @ts-nocheck
// fetch all freelancers
export const FETCH_FREELANCER_EVENT_REQUEST = "FETCH_FREELANCER_EVENT_REQUEST";
export const FETCH_FREELANCER_EVENT_SUCCESS = "FETCH_FREELANCER_EVENT_SUCCESS";
export const FETCH_FREELANCER_EVENT_FAILURE = "FETCH_FREELANCER_EVENT_FAILURE";

// update freelancer rate of position
export const UPDATE_FREELANCE_POSITION_RATE_REQUEST =
  "UPDATE_FREELANCE_POSITION_RATE_REQUEST";
export const UPDATE_FREELANCE_POSITION_RATE_SUCCESS =
  "UPDATE_FREELANCE_POSITION_RATE_SUCCESS";
export const UPDATE_FREELANCE_POSITION_RATE_FAILURE =
  "UPDATE_FREELANCE_POSITION_RATE_FAILURE";

// update freelancer expense and total
export const UPDATE_FREELANCE_EXPENSE_AND_TOTAL_REQUEST =
  "UPDATE_FREELANCE_EXPENSE_AND_TOTAL_REQUEST";
export const UPDATE_FREELANCE_EXPENSE_AND_TOTAL_SUCCESS =
  "UPDATE_FREELANCE_EXPENSE_AND_TOTAL_SUCCESS";
export const UPDATE_FREELANCE_EXPENSE_AND_TOTAL_FAILURE =
  "UPDATE_FREELANCE_EXPENSE_AND_TOTAL_FAILURE";

// update freelance po status
export const UPDATE_FREELANCE_PO_STATUS_REQUEST =
  "UPDATE_FREELANCE_PO_STATUS_REQUEST";
export const UPDATE_FREELANCE_PO_STATUS_SUCCESS =
  "UPDATE_FREELANCE_PO_STATUS_SUCCESS";
export const UPDATE_FREELANCE_PO_STATUS_FAILURE =
  "UPDATE_FREELANCE_PO_STATUS_FAILURE";